import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, RadioGroup, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { DL_CATEGORY_OPTIONS, isDlCategory } from '../../constants/driver';
import { contentKeys } from '../../constants/contentKeys';

const DriverCategoryStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.koerekort.dl_category).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const handleSelect = (value: string) => {
    if (isDlCategory(value)) {
      updateSelfServiceData('dlCategory', value);
    }
  };

  const handleNext = () => {
    if (selfServiceData.dlCategory) {
      goNext();
    }
  };

  return (
    <StepContainer title="Hvilken kørekortkategori søger du om?">
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <RadioGroup
        name="dlCategory"
        options={DL_CATEGORY_OPTIONS}
        value={selfServiceData.dlCategory}
        onChange={handleSelect}
        legend="Vælg kørekortkategori"
        required={true}
      />
      <NavigationButtons onBack={goBack} onNext={handleNext} nextDisabled={!selfServiceData.dlCategory} />
    </StepContainer>
  );
};

export default DriverCategoryStep;



